import axiosInst from "api/config/axiosConfig";

export const deviceTypes = {
  megaFi1: "MegaFi-1",
  megaFi2: "MegaFi-2",
  aw12: "AW12",
};

export interface SoftwareVersionTypes {
  swVersion: string;
  deviceCount: number;
}

export const getSystemInfo = async (version: string) => {
  const response = await axiosInst.get(`/beta/appSystemInfo?megafitype=${version}`);
  return response.data;
};
